import { render, staticRenderFns } from "./CanteenSubject.vue?vue&type=template&id=a96c2aa4&scoped=true&"
import script from "./CanteenSubject.vue?vue&type=script&lang=ts&"
export * from "./CanteenSubject.vue?vue&type=script&lang=ts&"
import style0 from "./CanteenSubject.vue?vue&type=style&index=0&id=a96c2aa4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a96c2aa4",
  null
  
)

export default component.exports